import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NcarbLoginComponent } from '../ncarb/ncarb-login/ncarb-login.component';

const routes: Routes = [
  {
    path: '**',
    component: NcarbLoginComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class NcarbRoutingModule {}
